export default {
    loading : false,
    branchOffices: [],
    voucher_types : [],
    report_data:[],
    document_referrals:[],
    contacts: [],
    product_details_document: [],
    product_id_details_document_query: null,
    params: {
        date : null,
        //voucher_type : null,
        branch_office : null,
        contact : [],
        template : null,
    },
    params_query:{
        is_customer: false,
        is_provider: false,
        is_employee: false,
        filter_customer: [],
        filter_provider: [],
        filter_employee: [],
        paginate: true,
        page: 1,
        perPage: 50,
        query: '',
        sortBy: 'id',
        sort: 'ASC',
    },
    params_voucher_type:{
        paginate : false,
        filter : null,
        branchoffice : null,
    },
    ag_grid:{
        selectedTheme:'ag-theme-balham'
    },
    name_pdf: null,
    column_status: null,
    paramsTemplates:{
        perPage: 1000,
        sortBy: 'id',
        sort: 'ASC',
        paginate : true,
        filter : null,
        active: 1
    },
    templates: []
}



// WEBPACK FOOTER //
// ./src/modules/report-sales-referrals/state.js